// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AddressAutocompleteController from "./address_autocomplete_controller";
application.register("address-autocomplete", AddressAutocompleteController);

// Autocomplete controller from RailsBlocks
import AutocompleteController from "./autocomplete_controller";
application.register("autocomplete", AutocompleteController);

// Reusable Banner component with countdown and cookie management
import BannerController from "./banner_controller";
application.register("banner", BannerController);

// Beta tester signup form controller
import BetaTesterSignupController from "./beta_tester_signup_controller";
application.register("beta-tester-signup", BetaTesterSignupController);

// Universal BlockNote editor controllers
import BlocksTextEditorController from "./blocks_text_editor_controller";
application.register("blocks-text-editor", BlocksTextEditorController);

import BlocksTextAutosaveController from "./blocks_text_autosave_controller";
application.register("blocks-text-autosave", BlocksTextAutosaveController);

import BulkActionsController from "./bulk_actions_controller";
application.register("bulk-actions", BulkActionsController);

import BulkSelectController from "./bulk_select_controller";
application.register("bulk-select", BulkSelectController);

// Cache action controller for admin cache management
import CacheActionController from "./cache_action_controller";
application.register("cache-action", CacheActionController);

import ColorPreviewController from "./color_preview_controller";
application.register("color-preview", ColorPreviewController);

// Contact Form controller for support contact form
import ContactFormController from "./contact_form_controller";
application.register("contact-form", ContactFormController);

// Newsletter settings controllers
import ConnectionTestController from "./connection_test_controller";
application.register("connection-test", ConnectionTestController);

import RefreshListsController from "./refresh_lists_controller";
application.register("refresh-lists", RefreshListsController);

// Cookie preferences modal controller
import CookiePreferencesController from "./cookie_preferences_controller";
application.register("cookie-preferences", CookiePreferencesController);

// CTA settings controller for admin page form
import CtaSettingsController from "./cta_settings_controller";
application.register("cta-settings", CtaSettingsController);

// Context filter controller
import ContextFilterController from "./context_filter_controller";
application.register("context-filter", ContextFilterController);

import DrawerController from "./drawer_controller";
application.register("drawer", DrawerController);

import DrawerTriggerController from "./drawer_trigger_controller";
application.register("drawer-trigger", DrawerTriggerController);

import DropdownPopoverController from "./dropdown_popover_controller";
application.register("dropdown-popover", DropdownPopoverController);

import DropzoneController from "./dropzone_controller";
application.register("dropzone", DropzoneController);

// Element Tag Input controller for screenplay element autocomplete
import ElementTagInputController from "./element_tag_input_controller";
application.register("element-tag-input", ElementTagInputController);

// FAQ Accordion controller for support FAQs
import FaqAccordionController from "./faq_accordion_controller";
application.register("faq-accordion", FaqAccordionController);

// Flyout menu controller
import FlyoutMenuController from "./flyout_menu_controller";
application.register("flyout-menu", FlyoutMenuController);

// Group member filter controller
import GroupMemberFilterController from "./group_member_filter_controller";
application.register("group-member-filter", GroupMemberFilterController);

import HomepageController from "./homepage_controller";
application.register("homepage", HomepageController);

import ImagePreviewController from "./image_preview_controller";
application.register("image-preview", ImagePreviewController);

import LottieAnimationController from "./lottie_animation_controller";
application.register("lottie-animation", LottieAnimationController);

import MenuController from "./menu_controller";
application.register("menu", MenuController);

import MobileMenuController from "./mobile_menu_controller";
application.register("mobile-menu", MobileMenuController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import ModalTriggerController from "./modal_trigger_controller";
application.register("modal-trigger", ModalTriggerController);

// Media Browser controllers
import MediaBrowserSearchController from "./media_browser_search_controller";
application.register("media-browser-search", MediaBrowserSearchController);

import MediaBrowserSelectionController from "./media_browser_selection_controller";
application.register("media-browser-selection", MediaBrowserSelectionController);

import MediaBrowserSubmitController from "./media_browser_submit_controller";
application.register("media-browser-submit", MediaBrowserSubmitController);

// Admin Media Management controllers
import MediaFiltersController from "./media_filters_controller";
application.register("media-filters", MediaFiltersController);

import MediaUsageController from "./media_usage_controller";
application.register("media-usage", MediaUsageController);

import MediaBulkActionsController from "./media_bulk_actions_controller";
application.register("media-bulk-actions", MediaBulkActionsController);

import MediaRowController from "./media_row_controller";
application.register("media-row", MediaRowController);

// Media Preview Modal controller for user media management
import MediaPreviewController from "./media_preview_controller";
application.register("media-preview", MediaPreviewController);

import MultiSelectController from "./multi_select_controller";
application.register("multi-select", MultiSelectController);

// Navbar controller
import NavbarController from "./navbar_controller";
application.register("navbar", NavbarController);

// Newsletter form controller for newsletter sign-up blocks
import NewsletterFormController from "./newsletter_form_controller";
application.register("newsletter-form", NewsletterFormController);

// Objective display controllers
import ObjectiveDisclosureController from "./objective_disclosure_controller";
application.register("objective-disclosure", ObjectiveDisclosureController);

// Page cache clear controller for individual page cache management
import PageCacheClearController from "./page_cache_clear_controller";
application.register("page-cache-clear", PageCacheClearController);

import PageTypeFormController from "./page_type_form_controller";
application.register("page-type-form", PageTypeFormController);

// Phase filter controller for project phase filtering
import PhaseFilterController from "./phase_filter_controller";
application.register("phase-filter", PhaseFilterController);

// Schema Generator controller for Schema.org structured data
import SchemaGeneratorController from "./schema_generator_controller";
application.register("schema-generator", SchemaGeneratorController);

import SelectController from "./select_controller";
application.register("select", SelectController);

// Subscription edit controller for admin tier change warnings
import SubscriptionEditController from "./subscription_edit_controller";
application.register("subscription-edit", SubscriptionEditController);

import SlideoverController from "./slideover_controller";
application.register("slideover", SlideoverController);

import SlideoverTriggerController from "./slideover_trigger_controller";
application.register("slideover-trigger", SlideoverTriggerController);

import SortableController from "./sortable_controller";
application.register("sortable", SortableController);

import ThemeController from "./theme_controller";
application.register("theme", ThemeController);

import ToastController from "./toast_controller";
application.register("toast", ToastController);

// TOC controllers for table of contents functionality
import TocCollapseController from "./toc_collapse_controller";
application.register("toc-collapse", TocCollapseController);

import TocSettingsController from "./toc_settings_controller";
application.register("toc-settings", TocSettingsController);

// TOC Active controller for active section highlighting in sidebar TOC
import TocActiveController from "./toc_active_controller";
application.register("toc-active", TocActiveController);

// Toggle fields controller for showing/hiding form fields
import ToggleFieldsController from "./toggle_fields_controller";
application.register("toggle-fields", ToggleFieldsController);

import TooltipController from "./tooltip_controller";
application.register("tooltip", TooltipController);

import VideoEmbedController from "./video_embed_controller";
application.register("video-embed", VideoEmbedController);

// Warming progress controller for cache warming progress updates
import WarmingProgressController from "./warming_progress_controller";
application.register("warming-progress", WarmingProgressController);

// AI Integration Controller
import AiMetaDescriptionController from "./ai_meta_description_controller";
application.register("ai-meta-description", AiMetaDescriptionController);
